import { CustomModelOrSnapshotIcon } from '@salescore/client-common'
import type { CoreModel } from '@salescore/core'
import type { ReactElement } from 'react'

export const ModelLabel = ({ model }: { model: CoreModel }): ReactElement => (
  <span className="whitespace-pre-wrap break-all">
    <CustomModelOrSnapshotIcon model={model} />
    <span>{model.label}</span>
  </span>
)
